// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3n2xnit7tS5cnEawJw8ljw{border:none;cursor:pointer;-webkit-appearance:none}._3n2xnit7tS5cnEawJw8ljw,._3n2xnit7tS5cnEawJw8ljw:hover{background:none;color:inherit;text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "_3n2xnit7tS5cnEawJw8ljw"
};
module.exports = ___CSS_LOADER_EXPORT___;
